import { env } from '@shared/config/env';
import { EXTERNAL_FORM_DEFAULTS, EXTERNAL_FORM_FONTS, LOGO_POSITIONS, isHexColor } from './constants';

const hexOrDefault = (value, fallback) => {
  const normalized = typeof value === 'string' ? value.toUpperCase() : '';
  return isHexColor(normalized) ? normalized : fallback;
};

const resolveLogoUrl = (logo) => {
  if (!logo || typeof logo !== 'string') return null;
  if (logo.startsWith('http://') || logo.startsWith('https://') || logo.startsWith('blob:')) return logo;
  if (logo.startsWith('/')) {
    const base = (env.URL_SERVER_BACKEND || '').replace(/\/$/, '');
    return `${base}${logo}`;
  }
  return logo;
};

export const externalFormFromDto = (dto = {}) => ({
  logo: resolveLogoUrl(dto?.logo),
  title: dto?.title || EXTERNAL_FORM_DEFAULTS.title,
  subtitle: dto?.subtitle || EXTERNAL_FORM_DEFAULTS.subtitle,
  fontFamily: EXTERNAL_FORM_FONTS.includes(dto?.font_family) ? dto.font_family : EXTERNAL_FORM_DEFAULTS.fontFamily,
  primaryColor: hexOrDefault(dto?.primary_color, EXTERNAL_FORM_DEFAULTS.primaryColor),
  textColor: hexOrDefault(dto?.text_color, EXTERNAL_FORM_DEFAULTS.textColor),
  logoPosition: LOGO_POSITIONS.includes(dto?.logo_position) ? dto.logo_position : EXTERNAL_FORM_DEFAULTS.logoPosition,
});

export const externalFormLinkFromDto = (dto) => {
  if (!dto?.link?.url) return null;
  return {
    url: dto.link.url,
    token: dto.link.token,
    createdAt: dto.link.created_at,
  };
};

export const externalFormToDto = (form) => ({
  title: form.title.trim(),
  subtitle: form.subtitle.trim(),
  font_family: form.fontFamily,
  primary_color: form.primaryColor,
  text_color: form.textColor,
  logo_position: form.logoPosition === 'center' ? 'center' : 'left',
});

export const externalFormLinkFromResponse = (dto) => ({
  url: dto.url,
  token: dto.token,
  createdAt: dto.created_at,
});
